module.exports = __webpack_public_path__ + "img/360tour.b1dc36e.png";